import { string, number, object } from 'yup';

export const validationSchema = object().shape({
  title: string().nullable().required('Title is required'),
  description: string().nullable(),
  nominalCode: string().nullable(),
  amount: number().nullable().required('Price is required'),
});
